"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinoLogEntryProcessor = void 0;
class PinoLogEntryProcessor {
    constructor(pinoInstance) {
        this.pinoInstance = pinoInstance;
    }
    child(context) {
        return new PinoLogEntryProcessor(this.pinoInstance.child(context || {}));
    }
    write(entry) {
        let { message, context, interpolationValues } = entry;
        interpolationValues = interpolationValues || [];
        if (typeof context === 'string') {
            interpolationValues = [message, ...interpolationValues];
            message = context;
            context = undefined;
        }
        this.pinoInstance[entry.level](context, message, ...interpolationValues);
    }
}
exports.PinoLogEntryProcessor = PinoLogEntryProcessor;
//# sourceMappingURL=pino-processor.js.map